export default class ServiceError extends Error {
  static STATUS_UNAUTHORIZED = 401
  static STATUS_FORBIDDEN = 403
  static STATUS_SERVER_ERROR = 500
  static STATUS_CONNECTION_ERROR = 502
  static STATUS_INVALID_DATA = 900

  constructor(statusCode, message) {
    super(message)
    this.statusCode = statusCode
  }

  getStatusCode() {
    return this.statusCode
  }
}
